import React, { Component } from "react";
import CoursePreview from "./CoursePreview";
import CourseEditor from "./CourseEditor";
import { course, elements } from "./Export";
import Constant from "../../../Constant";

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  console.log(result);
  return result;
};

export default class CourseContainer extends Component {
  state = {
    course: course,
    pageEditing: false,
    currentPage: {
      elements: [],
    },
  };

  componentDidMount() {
    if (this.props.currentPage) {
      this.setState({
        currentPage: this.props.currentPage,
        topicName: this.props.unitDetails.name,
        description: this.props.unitDetails.description,
        editing: true,
      });
    }
  }

  addPage = (id, pageName) => {
    var duplicateElements = JSON.parse(JSON.stringify(elements));

    var page = {};
    page.name = pageName;
    var id = this.state.course.length + 1;

    page.id = id.toString();
    page.exist = true;
    page.elements = duplicateElements;
    var course = this.state.course;
    course.push(page);

    this.setState({ course: course });
  };
  removePage = (id) => {
    var course = this.state.course;
    var currentPage = this.state.currentPage;
    for (let i = 0; i < course.length; i++) {
      if (course[i].id == id) {
        course.splice(i, 1);
      }
    }
    if (currentPage.id == id) {
      var emptyPage = {
        elements: [],
      };
      this.setState({ currentPage: emptyPage });
    }

    this.setState({ course: course });
  };
  addElement = (id) => {
    var course = this.state.course;
    var currentPage = this.state.currentPage;
    var elements = this.state.currentPage.elements;

    for (let j = 0; j < elements.length; j++) {
      if (elements[j].id == id) {
        elements[j].exist = true;
      }
    }

    for (let i = 0; i < course.length; i++) {
      if (course[i].id == currentPage.id) {
        course[i].elements = currentPage.elements;
      }
    }

    this.setState({ course: course });
  };
  removeElement = (id) => {
    var course = this.state.course;
    var currentPage = this.state.currentPage;
    var elements = this.state.currentPage.elements;

    for (let i = 0; i < elements.length; i++) {
      if (elements[i].id == id) {
        elements[i].exist = false;
      }
    }

    for (let i = 0; i < course.length; i++) {
      if (course[i].id == currentPage.id) {
        course[i].elements = currentPage.elements;
      }
    }

    this.setState({ course: course });
  };
  closeEditing = () => {
    var course = this.state.course;
    var currentPage = this.state.currentPage;

    for (let i = 0; i < course.length; i++) {
      if (course[i].id == currentPage.id) {
        course[i].elements = currentPage.elements;
      }
    }

    this.setState({ course: course, pageEditing: false });
  };
  startEditing = (id) => {
    var course = this.state.course;
    var currentPage = this.state.currentPage;
    for (let i = 0; i < course.length; i++) {
      if (course[i].id == id) {
        currentPage = course[i];
      }
    }

    this.setState({ currentPage: currentPage, pageEditing: true });
  };
  onDuplicatePage = (id) => {
    var course = this.state.course;
    var duplicateCourse = {};

    for (let i = 0; i < course.length; i++) {
      if (course[i].id === id) {
        duplicateCourse.name = course[i].name;
        var id = this.state.course.length + 1;
        duplicateCourse.id = id.toString();
        duplicateCourse.exist = true;
        var duplicateElements = course[i].elements;
        duplicateCourse.elements = JSON.parse(
          JSON.stringify(duplicateElements)
        );
        var index = i;
      }
    }
    course.splice(index + 1, 0, duplicateCourse);
    this.setState({ course: course });
  };
  onRenamePage = (id) => {
    var course = this.state.course;
    for (let i = 0; i < course.length; i++) {
      course[i].renameEditing = false;
      if (course[i].id == id) {
        course[i].renameEditing = true;
      }
    }
    this.setState({ course: course });
  };
  renamePageDone = (id, pageName) => {
    var course = this.state.course;
    for (let i = 0; i < course.length; i++) {
      course[i].renameEditing = false;

      if (course[i].id == id) {
        course[i].name = pageName;
      }
    }

    this.setState({ course: course });
  };

  onDragCourse = (result) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }
    const sortCourse = reorder(
      this.state.course,
      result.source.index,
      result.destination.index
    );

    this.setState({
      course: sortCourse,
    });
  };
  onDragElement = (result) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }
    var currentPage = this.state.currentPage;
    var elements = currentPage.elements;
    const sortElements = reorder(
      elements,
      result.source.index,
      result.destination.index
    );

    currentPage.elements = sortElements;
    this.setState({
      currentPage: currentPage,
    });
  };
  onDuplicateElement = (id) => {
    var course = this.state.course;
    var currentPage = this.state.currentPage;
    var elements = currentPage.elements;

    var course = this.state.course;
    var duplicateElement = {};

    for (let i = 0; i < elements.length; i++) {
      if (elements[i].id === id) {
        var id = elements.length + 1;
        duplicateElement.id = id.toString();
        duplicateElement.type = elements[i].type;
        duplicateElement.name = elements[i].name;
        duplicateElement.exist = true;
        var duplicateData = elements[i].data;
        duplicateElement.data = JSON.parse(JSON.stringify(duplicateData));

        var index = i;
      }
    }
    elements.splice(index + 1, 0, duplicateElement);
    this.setState({ currentPage: currentPage });
  };
  onSaveData = (data, elementId) => {
    var course = this.state.course;
    var currentPage = this.state.currentPage;
    var elements = this.state.currentPage.elements;
    for (let i = 0; i < elements.length; i++) {
      if (elements[i].id == elementId) {
        elements[i].data = data;

        console.log(data);
      }
    }

    for (let j = 0; j < course.length; j++) {
      if (course[j].id == currentPage.id) {
        course[j] = currentPage;
      }
    }
    this.setState({ course: course, currentPage: currentPage });
  };
  addTopic = () => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append(
      "Authorization",
      localStorage.getItem("livelms_auth")
    );

    var content = {
      topicType: "6",
      data: this.state.currentPage,
    };

    var urlencoded = new URLSearchParams();
    urlencoded.append("siteId", localStorage.getItem("lms_site_id"));
    urlencoded.append("name", this.state.topicName);
    urlencoded.append("description", this.state.description);
    urlencoded.append("image", this.state.image);
    urlencoded.append("contentType", "course");
    urlencoded.append("content", JSON.stringify(content));
    if (this.state.editing === true) {
      urlencoded.append("topicId", this.props.topic_id);
    } else {
      urlencoded.append("courseId", this.props.match.params.course_id);
    }
    urlencoded.append("start", new Date().toISOString());
    // urlencoded.append("end", data.contentType);
    urlencoded.append("isLive", false);
    urlencoded.append("duration", "15");
    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    var url;
    if (this.state.editing === true) {
      url = "/topic/update";
    } else {
      url = "/topic/add";
    }

    fetch(Constant.getAPI() + url, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (this.state.editing === true) {
          window.location.href = `#/admin/view-topic/${this.props.course_id}&${this.props.topic_id}`;
        } else {
          window.location.href = `#/admin/course/topics/${this.props.match.params.course_id}`;
        }

      })
      .catch((error) => console.log("error", error));
  };
  setTopicName = (name) => {
    this.setState({ topicName: name });
  };
  onInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value })
  }
  render() {
    return (
      <div className="row m-0 create-html">
        <div className="col-4 bar-left bg-white shadow">
          <div className="row m-0">
            <div class="card-body border-top">
              <div className="form-group mt-3">
                <label htmlFor="topicName">Unit Name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Topic Name"
                  name="topicName"
                  onChange={this.onInputChange}
                  value={this.state.topicName}
                />
              </div>
              <div className="form-group">
                <label htmlFor="topicName">Description</label>
                <textarea
                  type="text"
                  className="form-control"
                  placeholder="Enter Topic Name"
                  name="description"
                  onChange={this.onInputChange}
                  value={this.state.description}
                />
              </div>
            </div>
          </div>
          <CourseEditor
            setTopicName={this.setTopicName}
            course={this.state.course}
            addElement={this.addElement}
            removeElement={this.removeElement}
            addPage={this.addPage}
            removePage={this.removePage}
            pageEditing={this.state.pageEditing}
            currentPage={this.state.currentPage}
            closeEditing={this.closeEditing}
            startEditing={this.startEditing}
            onDuplicatePage={this.onDuplicatePage}
            onRenamePage={this.onRenamePage}
            renamePageDone={this.renamePageDone}
            onDragCourse={this.onDragCourse}
            onDragElement={this.onDragElement}
            onDuplicateElement={this.onDuplicateElement}
            addTopic={this.addTopic}
          ></CourseEditor>
        </div>
        <div className="col-8 bar-right">
          {this.state.preview ? (
            <div class="row">
              <div class="col-md-12 d-flex align-items-stretch grid-margin">
                <div class="row flex-grow">
                  <div class="col-12">
                    <div class="card">
                      <div class="card-body d-flex justify-content-between align-items-center">
                        <h4 class="border-none m-0">
                          {this.state.unitDetails.unit_name}
                          {this.state.preview}
                          <p></p>
                        </h4>
                        <div
                          className="btn btn-danger pull-right"
                          onClick={this.closePreview}
                        >
                          <i class="fas fa-times"></i> CLOSE
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
              <div class="row">
                <div class="col-md-12 d-flex align-items-stretch grid-margin">
                  <div class="w-100 bg-white">
                    <div class="card-body">
                      <CoursePreview
                        editMode={true}
                        currentPage={this.state.currentPage}
                        course={this.state.course}
                        onSaveData={this.onSaveData}
                      ></CoursePreview>
                    </div>
                  </div>
                </div>
              </div>
            )}
        </div>
      </div>
    );
  }
}
